import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EventRegistrationFormProvider } from '../context/EventRegistrationForm';
import { FormController } from './FormController';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { I18nextProvider } from 'react-i18next';
import i18nMod from '../i18n/i18n';
import { ThemeProvider } from '@mui/material';
import { theme } from '../theme';
import { FormCheckpointProvider } from '../context/FormCheckpoint';
import { FormValidationProvider } from '../context/FormValidation';
import { useIsMobile } from '../hooks/use-is-mobile';

type RegistrationFormComponentProps = {
  eventId?: number;
};

export const RegistrationFormComponent: React.FC<RegistrationFormComponentProps> = props => {
  const [searchParams] = useSearchParams();
  const isMobile = useIsMobile();
  const eventId: number = useMemo(() => {
    if (props.eventId) {
      return props.eventId;
    }
    const eventIdString = searchParams.get('eventId');
    if (eventIdString != null) {
      return parseInt(eventIdString);
    }
    return -1;
  }, [searchParams, props.eventId]);

  return (
    <I18nextProvider i18n={i18nMod}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <EventRegistrationFormProvider eventId={eventId}>
          <FormCheckpointProvider>
            <FormValidationProvider>
              <ThemeProvider theme={theme}>
                <div className="App" style={isMobile ? { marginBottom: 45 } : {}}>
                  <FormController />
                </div>
              </ThemeProvider>
            </FormValidationProvider>
          </FormCheckpointProvider>
        </EventRegistrationFormProvider>
      </LocalizationProvider>
    </I18nextProvider>
  );
};
